import { collapseQuillBlankParagraphs } from '../../utils/collapseQuillBlankParagraphs';
import TeamSocialLinks from './TeamSocialLinks';
import { optimizeImageUrl, IMAGE_DISPLAY_WIDTH } from '../../utils/optimizeImageUrl.js';
import './Founders.css';

const Founders = ({ founders = [] }) => {
    if (!Array.isArray(founders) || founders.length === 0) return null;

    return (
        <div className="founders-section">
            {founders.map((founder, index) => {
                const hasImage = Boolean(founder.profilePicUrl);
                const rawQuote = String(founder.bio || '').trim();
                const quote = rawQuote
                    .replace(/^[\s"'“”‘’]+/, '')
                    .replace(/[\s"'“”‘’]+$/, '');
                const quoteHtml = quote && !/[<>]/.test(quote)
                    ? quote.replace(/\n/g, '<br/>')
                    : collapseQuillBlankParagraphs(quote);

                return (
                    <div
                        key={founder.id || `${founder.fullName || 'founder'}-${index}`}
                        className={`founder-card ${index % 2 === 1 ? 'reverse' : ''}`.trim()}
                    >
                        <div className="founder-image-wrapper">
                            {hasImage ? (
                                <img
                                    alt={founder.fullName || 'Team member'}
                                    className="founder-image"
                                    src={optimizeImageUrl(founder.profilePicUrl, {
                                      width: IMAGE_DISPLAY_WIDTH.gallery
                                    })}
                                    loading="lazy"
                                    decoding="async"
                                />
                            ) : (
                                <div className="founder-image" />
                            )}
                        </div>
                        <div className="founder-info">
                            <div className="founder-header-block">
                                <div className="founder-name" role="heading" aria-level={2}>
                                    {founder.fullName || 'Team Member'}
                                </div>
                                <div className="founder-role-row">
                                    {founder.designation ? (
                                        <div className="founder-role">{founder.designation}</div>
                                    ) : (
                                        <span className="founder-role-spacer" aria-hidden="true" />
                                    )}
                                    <TeamSocialLinks member={founder} className="founder-socials" />
                                </div>
                            </div>
                            {quoteHtml ? (
                                <div
                                    className="founder-quote"
                                    dangerouslySetInnerHTML={{ __html: quoteHtml }}
                                />
                            ) : null}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default Founders;
